const StyleManagerMixin = {
  methods: {
    getIframeDocument: function () {
      try {
        const iframe = document.querySelector("iframe");
        if (!iframe) {
          return null;
        }
        return iframe.contentDocument || iframe.contentWindow.document;
      } catch (error) {
        return null;
      }
    },

    changeColorsTheme: function () {
      document.body.classList.add("no-transition");

      const isDarkMode = localStorage.getItem("isDarkMode") === "true";
      const iframeDoc = this.getIframeDocument();

      if (iframeDoc) {
        const fmDiv = iframeDoc.getElementById("fm");
        if (fmDiv) {
          fmDiv.classList.add("no-transition");
          if (isDarkMode) {
            fmDiv.classList.add("is-dark");
            setTimeout(() => {
              fmDiv.classList.remove("no-transition");
            }, 100);
          } else {
            fmDiv.classList.remove("is-dark");
            setTimeout(() => {
              fmDiv.classList.remove("no-transition");
            }, 100);
          }
        }
      }

      this.$nextTick(() => {
        document.body.classList.remove("is-dark", "is-light");
        document.body.classList.add(
          this.selectedStyle.darkMode ? "is-dark" : "is-light"
        );

        setTimeout(() => {
          document.body.classList.remove("no-transition");
        }, 100);
      });

      this.$store.commit("changeColorsTheme", {
        colors: this.selectedColors,
        style: this.selectedStyle,
        logo: this.lightLogoData,
        darkLogo: this.darkLogoData,
        favicon: this.faviconData,
      });
    },
  },
}

export default StyleManagerMixin